import { OrdersReporting } from "../../../OrdersReporting";
import { TopSelling } from "../TopSelling";
import { PeriodReport } from "../PeriodReport";

export function TabReport () {
  return (
    <>
      <ul className="nav nav-tabs" id="myTab" role="tablist">
        <li className="nav-item" role="presentation">
          <button className="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#home" type="button" role="tab" aria-controls="home" aria-selected="true">Pedidos</button>
        </li>
        <li className="nav-item" role="presentation">
          <button className="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile" type="button" role="tab" aria-controls="profile" aria-selected="false">Produtos vendidos</button>
        </li>
        <li className="nav-item" role="presentation">
          <button className="nav-link" id="daily-sales-tab" data-bs-toggle="tab" data-bs-target="#daily-sales" type="button" role="tab" aria-controls="daily-sales" aria-selected="false">Vendas por dia</button>
        </li>
      </ul>
      <div className="tab-content" id="myTabContent">
        <div className="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
          <OrdersReporting />
        </div>
        <div className="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
          <TopSelling />
        </div>
        <div className="tab-pane fade" id="daily-sales" role="tabpanel" aria-labelledby="daily-sales-tab">
          <PeriodReport type="daily" />
        </div>
      </div>
    </>
  )
}
